module.exports = __webpack_public_path__ + "static/image4-0bece00b90cad25e3145e48cdb20bac2.png";